// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import {
  getServerTimeFromState,
  getPromotionsData,
} from '@tcp/core/src/components/common/organisms/Promotions/container/Promotions.selectors';
import {
  getCurrentCurrency,
  getCurrencyAttributes,
} from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  openQuickViewWithValues,
  closeQuickViewModal,
  setPlpDataForQuickView,
  setSlpDataForQuickView,
  setQuickViewProductDetailPageTitle,
} from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import { getIsQVOpen } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.selectors';
import {
  getIsDisableDynamicBadgeFlagAbtest,
  getIsHideOriginalPriceAndMarchantTagEnabled,
  getCurrentCurrencySymbol,
  getIsBackToQuickviewCTAEnabled,
  getIsPromoMsgEnabledRecommendation,
  getIsTransparentImageSizeReduced,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getIsLoading } from './DyRecommendations.selector';
import { sendTrackEventsToDy } from './DyRecommendations.actions';
import DyRecommendationsView from '../views/DyRecommendations.view';

const mapStateToProps = (state, ownProps) => {
  const { page, topRecommendationOOS } = ownProps;
  return {
    currency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    isDynamicBadgeEnabledAbtest: getIsDisableDynamicBadgeFlagAbtest(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    currencySymbol: getCurrentCurrencySymbol(state),
    isQvModalOpen: getIsQVOpen(state),
    isBackToQuickviewCTAEnabled: getIsBackToQuickviewCTAEnabled(state),
    promotionsData: getPromotionsData(state),
    serverTime: getServerTimeFromState(state),
    isPromoMsgEnabledRecommendation: getIsPromoMsgEnabledRecommendation(state),
    isTransparentImageSizeReduceEnabled: getIsTransparentImageSizeReduced(state),
    isLoading: getIsLoading(state, page),
    isNewPDPEnabled: page === 'pdp' && !topRecommendationOOS,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    closeQvModal: () => {
      dispatch(setQuickViewProductDetailPageTitle(''));
      dispatch(closeQuickViewModal({ isModalOpen: false }));
      dispatch(setPlpDataForQuickView(null));
      dispatch(setSlpDataForQuickView(null));
    },
    sendTrackEventsToDy: (payload) => {
      dispatch(sendTrackEventsToDy(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DyRecommendationsView);
